import "phaser";
import Boot from "./scenes/Boot";
import Input from "./scenes/Input";
import Splash from "./scenes/Splash";
import GameScene from "./scenes/GameScene";
import WebFontLoaderPlugin from "./filetypes/WebFontFile";
import { gameArea } from "./utils/gameArea";
import PauseDeathScene from "./scenes/PauseDeathScene";
import HUDScene from "./scenes/HUDScene";
import MainMenuScene from "./scenes/MainMenuScene";
import TextBlurbScene from "./scenes/TextBlurbScene";


// main game configuration

export const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.WEBGL,
  render: {
    pixelArt: true
  },
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { y: 0, x: 0 },
      debug: false
    }
  },
  width: gameArea.screenWidth,
  height: gameArea.screenHeight,
  scale: {
    mode: Phaser.Scale.ScaleModes.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH
  },
  parent: "game",
  backgroundColor: '#131313',
  dom: {
    createContainer: true
  },
  input: {
    gamepad: true
  },
  scene: [ Boot, Input, Splash, GameScene, HUDScene, PauseDeathScene, MainMenuScene, TextBlurbScene ],
  plugins: {
    global: [{
        key : "WebFontLoader",
        plugin : WebFontLoaderPlugin,
        start: true
    }]
  }
}



const game = new Phaser.Game(config);
export default game;
